export const LOGO_MONACO = '/logo-monaco.png';
